module.exports = __webpack_public_path__ + "img/Icon-Zoom-in.2bbbf9af.svg";